import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import { Row as AntRow } from 'antd'
import { classNames } from 'utils/utils'
import withStyle from './Row.style.js'

const Row = ({ children, align, gutter, justify, className, style, type }) => (
  <AntRow
    align={align}
    gutter={gutter}
    justify={justify}
    type="flex"
    className={classNames('chec-row', type, className)}
    style={style}
  >
    {children}
  </AntRow>
)

Row.defaultProps = {
  align: 'middle',
  gutter: { xs: 12, sm: 12 },
  justify: 'start',
  children: [],
  style: { marginLeft: '6px', marginRight: '6px' },
  type: 'full',
}

Row.propTypes = {
  /** child elements typically should only be a <Col></Col> */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  /** vertical alignment */
  align: PropTypes.oneOf(['top', 'middle', 'bottom']),
  /** total distance between columns, set in defaultProps, shouldn't need to change */
  gutter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** horizontal flex justification */
  justify: PropTypes.oneOf([
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
  ]),
  /** className for custom styling */
  className: PropTypes.string,
  /** element style object, please don't use unless you have to */
  style: PropTypes.object,
  /** dunno what this does */
  type: PropTypes.oneOf(['full', 'inline']),
}

export default compose(withStyle)(Row)
